import React, { useEffect } from "react";
import { Routes, Route, Navigate, ScrollRestoration } from "react-router-dom";
import { useStateContext } from "./context/ContextProvider";

import "./App.css";

import Home from "./pages/Home";
import Home1 from "./pages/Home1";
import Home2 from "./pages/Home2";
import NotFound from "./pages/NotFound";
import Marketing from "./pages/Careers/Marketing";
import WebMobileApp from "./pages/LandingPages/WebMobileApp/WebMobileApp";
import LanguageWrapper from "./components/Language/LanguageWrapper";
import Thankyou from "./pages/Thankyou/Thankyou";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Services from "./pages/services";
import About from "./components/Home/About";
import Contact from "./components/Home/Contact";
import AboutPage from "./pages/AboutPage";
import MouseGrad from "./components/Effects/MouseGrad";
import SiteFooter from "./components/Footer/SiteFooter";
import HideNav from "./components/Navbar/HideNav";
import ScrollTopOnLoad from "./components/Essentials/ScrollTopOnLoad";
import useFadeInOnScroll from "./components/Effects/FadeInOnScroll";
import NoiseBackground from "./components/Background/NoiseBackground";
import BlogsPage from "./pages/Blogs/Blogs";
import SingleBlogPage from "./pages/Blogs/SingleBlog/SingleBlog";
import DoDealCRM from "./pages/services/Single/DoDealCRM";
import CreativeServices from "./pages/services/Single/CreativeServices";
import DigitalMarketing from "./pages/services/Single/DigitalMarketing";
import AdvertisingCampaigns from "./pages/services/Single/AdvertisingCampaigns";
import { Helmet } from "react-helmet";

const routes = [
  // HOME
  {
    path: "/",
    element: <Home />,
    pageName: "Home",
    language: "en",
    title: "DODEAL | Digital Marketing & Software Solutions",
    description: "DODEAL offers top-tier digital marketing, branding, and software development services to elevate your business.",
    keywords: "digital marketing, branding, software development, DODEAL",
  },
  {
    path: "/home",
    element: <Home />,
    pageName: "Home",
    language: "en",
    title: "DODEAL | Digital Marketing & Software Solutions",
    description: "DODEAL offers top-tier digital marketing, branding, and software development services to elevate your business.",
    keywords: "digital marketing, branding, software development, DODEAL",
  },
  {
    path: "/home1",
    element: <Home1 />,
    pageName: "Home",
    language: "en",
    title: "DODEAL | Digital Marketing & Software Solutions",
    description: "DODEAL offers top-tier digital marketing, branding, and software development services to elevate your business.",
    keywords: "digital marketing, branding, software development, DODEAL",
  },
  {
    path: "/home2",
    element: <Home2 />,
    pageName: "Home",
    language: "en",
    title: "DODEAL | Digital Marketing & Software Solutions",
    description: "DODEAL offers top-tier digital marketing, branding, and software development services to elevate your business.",
    keywords: "digital marketing, branding, software development, DODEAL",
  },
  {
    path: "/services",
    element: <Services />,
    pageName: "Services",
    language: "en",
    title: "Our Services | DODEAL",
    description: "Explore DODEAL's services, including digital marketing, CRM solutions, and creative branding.",
    keywords: "services, digital marketing, CRM, branding, DODEAL",
  },
  {
    path: "/about",
    // element: <About />,
    element: <AboutPage />,
    pageName: "About",
    title: "About DODEAL | Your Digital Partner",
    description: "Learn about DODEAL, a leader in digital marketing, branding, and software solutions.",
    keywords: "about DODEAL, digital marketing, branding, software",
  },
  {
    path: "/contact",
    element: <Contact />,
    pageName: "Contact",
    title: "Contact DODEAL | Get in Touch",
    description: "Reach out to DODEAL for inquiries about digital marketing, software, or branding services.",
    keywords: "contact DODEAL, digital marketing, software, branding",
  },

  // PRIVACY POLICY
  {
    path: "/privacypolicy",
    element: <PrivacyPolicy />,
    pageName: "Privacy Policy",
    language: "en",
    title: "Privacy Policy | DODEAL",
    description: "Read DODEAL's privacy policy to understand how we protect your data and ensure trust.",
    keywords: "privacy policy, DODEAL, data protection",
  },
  // THANK YOU
  {
    path: "/thankyou",
    element: <Thankyou />,
    pageName: "Thank you",
    title: "Thank You | DODEAL",
    description: "Thank you for contacting DODEAL. We'll get back to you soon with more information.",
    keywords: "thank you, DODEAL, contact confirmation",
  },
  // CAREERS
  // MARKETING
  {
    path: "/careers/marketing",
    element: <Marketing />,
    pageName: "Career in Marketing",
    language: "en",
    title: "Careers in Marketing | DODEAL",
    description: "Join DODEAL's marketing team and shape the future of digital marketing and branding.",
    keywords: "careers, marketing jobs, DODEAL, digital marketing",
  },
  // LANDING PAGES
  // WEBSITE AND MOBILE APP
  {
    path: "/web-mobile-apps",
    element: <WebMobileApp language={"English"} />,
    pageName: "Website and Mobile Apps",
    language: "en",
    title: "Web & Mobile Apps | DODEAL",
    description: "Discover DODEAL's web and mobile app development services for seamless user experiences.",
    keywords: "web development, mobile apps, DODEAL, software",
  },
  {
    path: "/web-mobile-apps/ar",
    element: <WebMobileApp language={"Arabic"} />,
    pageName: "Website and Mobile Apps",
    language: "ar",
    title: "Web & Mobile Apps | DODEAL",
    description: "Discover DODEAL's web and mobile app development services for seamless user experiences.",
    keywords: "web development, mobile apps, DODEAL, software",
  },
  // BLOGS 
  {
    path: "/blogs",
    element: <BlogsPage />,
    pageName: "Blogs",
    language: "en",
    title: "DODEAL Blog | Digital Marketing & Tech Insights",
    description: "Stay updated with the latest digital marketing trends, tech insights, and branding tips from DODEAL.",
    keywords: "digital marketing blog, tech insights, branding tips, DODEAL",
  },
  {
    path: "/blogs/:slug",
    element: <SingleBlogPage />,
    pageName: "Single Blog",
    language: "en",
    title: "", // Dynamic, set in SingleBlogPage
    description: "", // Dynamic, set in SingleBlogPage
    keywords: "", // Dynamic, set in SingleBlogPage
  },
  // SERVICES 
  {
    path: "/services/dodeal-crm",
    element: <DoDealCRM />,
    pageName: "DODEAL CRM",
    language: "en",
    title: "DoDeal CRM | DODEAL",
    description: "Streamline your business with DoDeal CRM, offered by DODEAL for efficient management.",
    keywords: "DoDeal CRM, business management, DODEAL, software",
  },
  {
    path: "/services/creative-services",
    element: <CreativeServices />,
    pageName: "Creative Services",
    language: "en",
    title: "Creative Services | DODEAL",
    description: "Elevate your brand with DODEAL's creative services, including design and content solutions.",
    keywords: "creative services, branding, design, DODEAL",
  },
  {
    path: "/services/digital-marketing",
    element: <DigitalMarketing />,
    pageName: "Digital Marketing",
    language: "en",
    title: "Digital Marketing | DODEAL",
    description: "Boost your online presence with DODEAL's tailored digital marketing services.",
    keywords: "digital marketing, online presence, DODEAL, SEO",
  },
  {
    path: "/services/advertising-and-campaigns",
    element: <AdvertisingCampaigns />,
    pageName: "Advertising and Campaigns",
    language: "en",
    title: "Advertising & Campaigns | DODEAL",
    description: "Drive success with DODEAL's targeted advertising and campaign solutions.",
    keywords: "advertising, campaigns, DODEAL, marketing",
  },
  // NOT FOUND
  {
    path: "/*",
    element: <NotFound />,
    pageName: "Not Found",
    title: "404 Not Found | DODEAL",
    description: "Page not found. Explore DODEAL for digital marketing, branding and software services.",
    keywords: "404, not found, DODEAL",
  },
];

function MetaWrapper({ children, route }) {
  const defaultTitle = "DODEAL | Digital Marketing & Software Solutions";
  const defaultDescription = "DODEAL offers top-tier digital marketing, branding, and software development services to elevate your business.";
  const defaultKeywords = "digital marketing, branding, software development, DODEAL";

  return (
    <>
      <Helmet>
        <title>{route.title || defaultTitle}</title>
        <meta name="description" content={route.description || defaultDescription} />
        <meta name="keywords" content={route.keywords || defaultKeywords} />
        <meta property="og:title" content={route.title || defaultTitle} />
        <meta property="og:description" content={route.description || defaultDescription} />
        <meta name="twitter:card" content="summary_large_image" />
        {route.language && <meta name="language" content={route.language} />}
      </Helmet>
      {children}
    </>
  );
}

function App() {
  const { setAllRoutes, i18n } = useStateContext();

  useFadeInOnScroll();

  useEffect(() => {
    setAllRoutes(routes);
    i18n.changeLanguage(localStorage.getItem("language"));
  }, [setAllRoutes, i18n]);

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
      }}
    >
      <NoiseBackground />
      <HideNav />
      <ScrollTopOnLoad />
      <Routes>
        {/* <Route path="/" element={
          <>
            <MouseGrad />
            <Home routes={routes} />
          </>
        } /> */}
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                route.pageName === "Single Blog" ? (
                  <LanguageWrapper language={route?.language}>
                    <MouseGrad />
                    {route.element}
                  </LanguageWrapper>
                ) : (
                  <MetaWrapper route={route}>
                    <LanguageWrapper language={route?.language}>
                      <MouseGrad />
                      {route.element}
                    </LanguageWrapper>
                  </MetaWrapper>
                )
              }
            />
          );
        })}
        <Route path="/home" element={<Navigate to="/" replace />} />
      </Routes>
      <div className="min-h-screen w-full py-5 my-5 flex items-center">
        <Contact />
      </div>
      <SiteFooter />
    </div>
  );
}

export default App;
